import style from "../../Pages/ServicesDisplay.module.css";
import aeps from "../images/ServiceDetailImg/AEPS.png";

const AEPS = () => {

    const features = [
        'Banking, as well as non-banking transactions, can be performed through a banking correspondent.',
        'Banking correspondents of one bank can perform transactions of other banks as well.',
        'People do not have to furnish their debit/credit card for making transactions through AePS.',
        'The fingerprint is needed for transaction authentication which makes it safer.',
        'Micro PoS machines can be taken to distant places enabling people in remote villages to make transactions instantly.'
    ];

    const facilities = [
        	'Cash Withdrawal',
	'Cash Deposit',
'	Balance Enquiry',
	'Aadhaar to Aadhaar Fund Transfer',
	'Mini Statement',
	'eKYC – Best Finger Detection/IRIS Detection',

    ]

    const step = [
        	'Visit a banking correspondent in your area. (It doesn’t matter if he is an executive of the bank you don’t have an account in, you can make transactions through AePS).',
 ,'Enter your 12-digit Aadhaar number in the PoS Machine.'
 ,'Select the transaction type – cash deposit, withdrawal, mini statement, fund transfer, balance enquiry or eKYC.'
 ,'Select the bank name.'
 ,'Enter the amount for the transaction.'
 ,'Authenticate the transaction using your biometric (fingerprint or iris scan).'
 ,'The transaction gets completed in seconds.' ,'A receipt will be given to you by the banking correspondent.'

    ]

    const points = [
       	"Your bank account should be linked with Aadhaar if you want to avail this service.",
"If you have more than one account in one bank, only the primary account will be used under AePS.",
"No OTP or PIN is required for making transactions through AePS.",
"AePS supports transactions between Aadhaar linked bank accounts only.",
"Multiple bank accounts can be linked with Aadhaar to avail AePS facility. However, only one account per bank can be used for availing this facility.",
"The cutover of transactions done through AePS takes place at 11 pm every day. Transactions done before this time for the day are included in this settlement.",

    ]

  return (
    <article className={style.ServiceDetailArticle}>
      <h1>AEPS</h1>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <picture>
          <img src={aeps}></img>
        </picture>
      </div>
      <p className={style.Paragraph}>
        <strong>
          {" "}
          AEPS is a bank led model which allows online interoperable financial
          transaction at PoS (Point of Sale / Micro ATM) through the Business
          Correspondent (BC)/Bank Mitra of any bank using the Aadhaar
          authentication.Fund Transfer Limits under AePS
        </strong>
        <br /> <br />
        Aadhaar Enabled Payment System (AePS) is a system developed by the
        National Payments Corporation of India (NPCI) that allows people to
        carry out financial transactions on a Micro-ATM by furnishing just their
        Aadhaar number and verifying it with the help of their fingerprint/iris
        scan.RBI has set no limit for transactions made through AePS. However,
        some banks have established a daily limit of a maximum of Rs. 50,000 on
        total transactions.
      </p>
    <div className={style.ulWrapper}>
    <ul>
      <h6>There are a number of benefits of AePS. Some of those are mentioned below:</h6>
      {features.map((item,i)=>(
        <li key={i}>{item}</li>
      
      )  )}
      </ul>
    </div>
    <div className={style.ulWrapper}>
    <ul>
    <h6>People can avail a total of 6 facilities through AePS. These are:</h6>
      {facilities.map((item,i)=>(
        <li key={i}>{item}</li>
      
      )  )}
      </ul>
    </div>

    <div className={style.ulWrapper}>
    <ul>
    <h6>The process of using AePS is quite easy. You have to follow these simple steps:</h6>
      {step.map((item,i)=>(
        <li key={i}>{item}</li>
      
      )  )}
      </ul>
    </div>

    <div className={style.ulWrapper}>
    <ul>
   <h6>You should remember these points before you use the new payment method:</h6>
      {points.map((item,i)=>(
        <li key={i}>{item}</li>
      
      )  )}
      </ul>
    </div>
    </article>
  );
};

export default AEPS;
